import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import Page from '../components/Page';
import { authenticateCognitoUser, getCognitoUser } from '../redux/auth';
import { Link } from 'inferno-router';
import { validators } from '../utils';

function mapStateToProps(state) {
  return {
    userInformation: state.auth.userInformation,
  };
}

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  handleLogin = e => {
    e.preventDefault();
    this.setState({ error: null });

    const { isValidEmail } = validators;
    const { email, password } = e.target;

    const userEmail = email.value.toLowerCase();
    const userPassword = password.value;

    if (!isValidEmail(userEmail)) {
      return this.setState({ error: 'Please Provide A Valid Email' });
    }
    const credentials = {
      userName: userEmail,
      password: userPassword,
    };
    return this.props
      .authenticateCognitoUser(credentials)
      .then(result => {
        this.props.getCognitoUser().then(userInfo => {
          // Set user display name in local storage so it does not have
          // to be fetched every time the user navigates to a new page
          window.localStorage.setItem('manomanoDisplayName', userInfo.name);
          if(this.props.params.verificationCode) {
            // Redirects user back to verification page with code
            return this.context.router.push(`/verify?verificationCode=${this.props.params.verificationCode}`);
          }
          // Redirects user to the home page
          const shareIdParam = window.localStorage.getItem('pendingDeckCopy');
          if (shareIdParam) {
            window.localStorage.removeItem('pendingDeckCopy');
            return this.context.router.push(
              `/flashcards?shareId=${shareIdParam}`
            );
          }
          this.context.router.push('/');
        });
      })
      .catch(err => {
        this.setState({ error: err.message });
      });
  };

  render() {
    return (
      <Page>
        <div className="login__form">
          <h1 className="section__title">E ʻeʻe i kāu moʻokāki<br />Log Into Your Account</h1>
          <div className="form__error">
            {this.state.error && <p>{this.state.error}</p>}
          </div>
          <form onsubmit={this.handleLogin}>
            <label className="form__field">
              <span className="form__label-text">Lekauila (Email Address)</span>
              <input
                className="form__input"
                name="email"
                type="text"
                required
              />
            </label>
            <label className="form__field">
              <span className="form__label-text">ʻŌlelo huna (Password)</span>
              <input
                className="form__input"
                name="password"
                type="password"
                required
              />
            </label>
            <button className="button button--form" type="submit">
              Log In
            </button>
            <Link className="link link--secondary" to="/forgot-password">
              Forgot Your Password?
            </Link>
            <Link className="link" to="/register">
              Create An Account &#8594;
            </Link>
          </form>
        </div>
      </Page>
    );
  }
}

export default connect(mapStateToProps, {
  authenticateCognitoUser,
  getCognitoUser,
})(Login);



// WEBPACK FOOTER //
// ./src/pages/Login.js